import { isGA, siteName } from 'lib/src/constants/environment';
import { Config } from '.';

export const IX_API_URL = 'https://api.ktninnovationexchange.co.uk';
export const GA_API_URL = 'https://api.ktn-global.org';
export const IX_WEB_URL = 'https://www.ktninnovationexchange.co.uk';
export const GA_WEB_URL = 'https://innovationexchange.ktn-global.org';

const config: Config = {
    API_URL: isGA ? GA_API_URL : IX_API_URL,
    S3_URL: 'https://s3-eu-west-1.amazonaws.com/ktn-media',
    SITE: siteName,
    WEB_URL: isGA ? GA_WEB_URL : IX_WEB_URL,
    IX_WEB_URL,
    GA_WEB_URL,
};

export default config;
